import { useState, useEffect, useRef, useMemo } from "react";
import { Switch } from "@headlessui/react";
import Checkbox from "./Checkbox";
import uploadIcon from "../assets/icons/uploadImg.svg";
import lockIcon from "../assets/icons/lock.svg";
import backIcon from "../assets/icons/back(1).svg";
import service from "../utils/request";
import message from "../utils/message";

export default function Proflie({selectedChildrenTab, setSelectedChildrenTab}) {

  const [enabled, setEnabled] = useState(false);
  const [selectedItems, setSelectedItems] = useState([
    {
      name: "iGarment",
      id: 1,
      isSelected: false,
    },
    {
      name: "Pad System",
      id: 2,
      isSelected: false,
    },
    {
      name: "Modular",
      id: 3,
      isSelected: false,
    },
    {
      name: "iWork",
      id: 4,
      isSelected: false,
    },
    {
      name: "Net Cloud",
      id: 5,
      isSelected: false,
    },
  ]);
  const [isHomePage, setIsHomePage] = useState(false);
  const [isResetPassword, setIsResetPassword] = useState(false);
  useEffect(() => {
    console.log(selectedChildrenTab)
    if(selectedChildrenTab !== ""){
      setIsResetPassword(selectedChildrenTab === "reset-password")
      setIsHomePage(false)

    } else {
      setIsHomePage(true)
    }
  }, [selectedChildrenTab]);
  const [userInfo, setUserInfo] = useState({});
  const [passwordObject, setPasswordObject] = useState({
    current_password: "",
    confirm_password: "",
    new_password: "",
  });
  const uploadRef = useRef(null);
  const isButtonDisabled = useMemo(() => {
    if (isResetPassword) {
      return hasEmptyValue(passwordObject)
    } else {
      return hasEmptyValue(userInfo, ['avatar', 'mobile_show'])
    }
  }, [isResetPassword, passwordObject, userInfo]);

  useEffect(() => {
    service.get("/user/profile").then((res) => {
      setUserInfo(res);
      setEnabled(res?.mobile_show);
    });
  }, []);

  const updateProfile = async () => {
    if(isButtonDisabled) {
      message('warn', 'please input all required fields')
      return
    }

    if (isResetPassword) {
      try {
        await service.put("/user/change_password", passwordObject);
        message("success", "Password changed successfully");
      } catch (error) {
        message("error", error);
      }
    } else {
      try {
        await service.put("/user/update_profile", userInfo);
        message("success", "Profile updated successfully");
      } catch (error) {
        message("error", error);
      }
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(",")[1]; // 获取 Base64 数据
        const imageSize =
          (base64.length * 3) / 4 -
          (base64.endsWith("==") ? 2 : base64.endsWith("=") ? 1 : 0); // 计算字节长度

        const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
        if (imageSize > MAX_FILE_SIZE) {
          alert("Avatar file size exceeds maximum limit of 5MB");
        } else {
          setUserInfo({ ...userInfo, avatar: base64 });
        }
      };
      reader.readAsDataURL(file);
    }
  };

  function handleImgChoosen() {
    if (uploadRef.current) {
      uploadRef.current.click();
    }
  }
  function hasEmptyValue(obj, excludeKeys = []) {
    return Object.entries(obj).some(([key, value]) => {
      if (excludeKeys.includes(key)) return false;

      return value === null || value === undefined || value === '' ||
             (Array.isArray(value) && value.length === 0);
    });
  }

  if(isHomePage) {
    return <div className=" relative pt-4">
      <h1 className="text-base text-left font-semibold text-gray-800 mb-4">My Profile</h1>
    </div>
  }


  return (
    <div className=" relative pt-4 px-4">
      <h1 className="text-base text-left font-semibold text-gray-800 mb-4">
        <span className="text-blue-600 hover:text-blue-700 underline cursor-pointer" onClick={() => {
          setIsHomePage(true);
          setSelectedChildrenTab("")
        }}>
          My Profile</span> / {isResetPassword ? "Reset Password" : "Profile"}</h1>
      {!isResetPassword ? (
        <>
          <div className="flex items-center">
            <span className=" text-xl">Avatar</span>
            <input
              type="file"
              accept="image/*"
              ref={uploadRef}
              className="hidden"
              onChange={handleImageChange}
            />
            <div
              onClick={handleImgChoosen}
              className="group relative cursor-pointer w-20 h-20 rounded-full bg-neutral-300 ml-16 flex items-center justify-center"
            >
              <img
                src={uploadIcon}
                alt=""
                className="w-7 hidden group-hover:block z-10"
              />
              {userInfo.avatar && (
                <img
                  src={`data:image/jpeg;base64,${userInfo.avatar}`}
                  alt="Selected"
                  className="w-full h-full object-cover rounded-full absolute"
                />
              )}
            </div>
          </div>
          <div className="flex items-center mt-6">
            <label className="text-left block  text-sm font-medium text-gray-900 w-32">
              Local Name
            </label>
            <input
              className="flex-1 bg-gray-50 outline-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              placeholder="Local Name"
              required
              value={userInfo.locale_name}
              onChange={(e) =>
                setUserInfo({ ...userInfo, locale_name: e.target.value })
              }
            />
          </div>
          <div className="flex items-center mt-6">
            <label className="text-left block  text-sm font-medium text-gray-900 w-32">
              Mobile
            </label>
            {!enabled ? (
              <div className="flex-1 w-full text-left">XXX-XXXX-XXXX</div>
            ) : (
              <input
                className="flex-1 bg-gray-50 outline-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder="Mobile"
                required
                value={userInfo.mobile}
                onChange={(e) =>
                  setUserInfo({ ...userInfo, mobile: e.target.value })
                }
              />
            )}

            <div className="px-6">
              <Switch
                checked={enabled}
                onChange={setEnabled}
                className="group inline-flex h-6 w-11 items-center rounded-full bg-gray-200 transition data-[checked]:bg-blue-600"
              >
                <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
              </Switch>
            </div>

            <span>( Mobile Show )</span>
          </div>
          <div className="flex items-center mt-6">
            <span className="text-left block  text-sm font-medium text-gray-900 w-32">
              Full Name
            </span>
            <input
              className="flex-1 bg-gray-50 outline-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              placeholder="Full Name"
              required
              value={userInfo.full_name}
              onChange={(e) =>
                setUserInfo({ ...userInfo, full_name: e.target.value })
              }
            />
          </div>
          <div className="flex items-center mt-6">
            <label className="text-left block  text-sm font-medium text-gray-900 w-32">
              Email
            </label>
            <input
              className="flex-1 bg-gray-50 outline-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              placeholder="Email"
              required
              value={userInfo.email}
              onChange={(e) =>
                setUserInfo({ ...userInfo, email: e.target.value })
              }
            />
          </div>
          <div className="flex items-center mt-6">
            {selectedItems.map((item, index) => (
              <div key={item.id} className="flex mr-8">
                <Checkbox
                  color="bg-zinc-500"
                  size="h-6 w-6"
                  checked={item.id === userInfo.company_id}
                  onChange={() =>
                    setUserInfo({ ...userInfo, company_id: item.id })
                  }
                />
                <span>{item.name}</span>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className="w-full h-8"></div>
          <div className="flex items-center mt-6">
            <label className="text-left block  text-sm font-medium text-gray-900 w-32">
              Current Password
            </label>
            <input
              className="flex-1 bg-gray-50 outline-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              placeholder="Current Password"
              required
              type="password"
              value={passwordObject.current_password}
              onChange={(e) =>
                setPasswordObject({
                  ...passwordObject,
                  current_password: e.target.value,
                })
              }
            />
          </div>
          <div className="flex items-center mt-6">
            <label className="text-left block  text-sm font-medium text-gray-900 w-32">
              New Password
            </label>
            <input
              className="flex-1 bg-gray-50 outline-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              placeholder="New Password"
              required
              type="password"
              value={passwordObject.new_password}
              onChange={(e) =>
                setPasswordObject({
                  ...passwordObject,
                  new_password: e.target.value,
                })
              }
            />
          </div>
          <div className="flex items-center mt-6">
            <label className="text-left block  text-sm font-medium text-gray-900 w-32">
              Confirm Password
            </label>
            <input
              className="flex-1 bg-gray-50 outline-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              placeholder="Confirm Password"
              required
              type="password"
              value={passwordObject.confirm_password}
              onChange={(e) =>
                setPasswordObject({
                  ...passwordObject,
                  confirm_password: e.target.value,
                })
              }
            />
          </div>
        </>
      )}
      <div className="flex justify-between items-center mt-16">
        <button
          className={`px-4 py-2  flex items-center rounded    ${isButtonDisabled ? 'cursor-not-allowed text-[#00000040] bg-[#00000012]' : 'cursor-pointer bg-[#ffa270] hover:bg-[#ffa270]/80 text-white'}`}
          onClick={updateProfile}
          // disabled={isButtonDisabled}
        >
          <span>Submit</span>
        </button>
      </div>
      {/* <button
          onClick={() => setIsResetPassword(!isResetPassword)}
          className=" absolute right-0 top-6 px-4 py-2 flex items-center  bg-zinc-400 text-white rounded hover:bg-zinc-500 "
        >
          {isResetPassword ? (
            <>
              <img src={backIcon} alt="" className="w-4 h-4 mr-1" />

              <span>Back To My Profile</span>
            </>
          ) : (
            <>
              <img src={lockIcon} alt="" className="w-4 h-4 mr-1" />
              <span>Reset Password</span>
            </>
          )}
        </button> */}
    </div>
  );
}
